
document.addEventListener('DOMContentLoaded', () => {
  const menuOpen = document.querySelector('[data-menu-open]');
  const menuClose = document.querySelector('[data-menu-close]');
  const drawer = document.querySelector('[data-drawer]');

  if (menuOpen && menuClose && drawer) {
    const setMenu = (open) => {
      drawer.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      menuOpen.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    menuOpen.addEventListener('click', () => setMenu(true));
    menuClose.addEventListener('click', () => setMenu(false));
    drawer.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => setMenu(false));
    });
  }

  document.querySelectorAll('[data-editorial-carousel]').forEach((carousel) => {
    const viewport = carousel.querySelector('[data-carousel-viewport]');
    const prev = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');

    if (!viewport) return;

    const distance = () => Math.max(280, Math.min(viewport.clientWidth * 0.8, 760));

    if (prev) {
      prev.addEventListener('click', () => {
        viewport.scrollBy({ left: -distance(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        viewport.scrollBy({ left: distance(), behavior: 'smooth' });
      });
    }
  });
});
